import React from "react";
import { Link, useParams } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import useTenantChildEntity from "./useTenantChildEntity";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";

const TenantChildEntity = () => {
  const {
    loading,
    entities,
    skeletonRows,
    totalRecords,
    first,
    rows,
    onPage,
    sortField,
    sortOrder,
    onSort,
  } = useTenantChildEntity();
  const { id: tenantId } = useParams();
  const handleCountryFlag = (rowData) => {
    return (
      <div className="country-tag">
        <ReactCountryFlag countryCode={rowData.country} svg />
        <span style={{ textTransform: "capitalize", marginLeft: "7px" }}>
          {getName(rowData.country)}
        </span>
      </div>
    );
  };
  const accountManagerTemplate = (rowData) => {
    const manager = rowData.accountManager;
    if (!manager) return "-";

    let name;
    if (manager.preferred_name) {
      name = manager.preferred_name;
    } else {
      const givenName = manager.given_name || "";
      const surname = manager.surname || "";
      name = `${givenName} ${surname}`.trim() || "-";
    }
    return (
      <Link
        to={`/tenants/${tenantId}/account-manager/${manager.id}`}
        className="account-manager-link"
      >
        {name}
      </Link>
    );
  };
  return (
    <DataTable
      value={loading ? skeletonRows : entities}
      lazy
      paginator={totalRecords > 10}
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPage={onPage}
      sortField={sortField}
      sortOrder={sortOrder}
      onSort={onSort}
      rowsPerPageOptions={[10, 20, 30]}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      emptyMessage={!loading && "No entities found"}
      className="datatable-right-align"
    >
      <Column
        field="name"
        header="Registered Name"
        sortable
        body={(row) =>
          loading ? (
            <Skeleton width="100%" />
          ) : (
            <Link to={`/entity/${row.id}/dashboard`} className="entity-link">
              {row.name || "-"}
            </Link>
          )
        }
      />

      <Column
        field="country"
        header="Country"
        sortable
        body={(row) =>
          loading ? (
            <Skeleton width="100%" />
          ) : (
            <>{handleCountryFlag(row)}</> || "-"
          )
        }
      />

      <Column
        field="type"
        header="Type"
        sortable
        body={(row) => (loading ? <Skeleton width="100%" /> : row.type || "-")}
      />

      <Column
        field="account_manager"
        header="Account Manager"
        sortable
        body={(row) =>
          loading ? <Skeleton width="100%" /> : accountManagerTemplate(row)
        }
      />
    </DataTable>
  );
};

export default TenantChildEntity;
